import { CheckCircle } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import { useCallback, useState } from "react";
import { YStack } from "tamagui";
import { Body } from "../../ui/Body";
import { Button } from "../../ui/Button";
import { Sheet } from "../../ui/Sheet";
import { TipsText } from "../../ui/TipsText";
import { Title } from "../../ui/Title";
import { DataItemsSelect } from "../elements/DataItemsSelect";
import type PollModuleModel from "./PollModuleModel";

export const PollDoneSheet: React.FC<{ module: PollModuleModel }> = observer(
  ({ module }) => {
    const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

    const handleOptionSelect = useCallback(
      (newOption: string) => {
        if (selectedOptions.includes(newOption)) {
          setSelectedOptions((options) =>
            options.filter((option) => option !== newOption),
          );
        } else {
          setSelectedOptions((options) => options.concat([newOption]));
        }
      },
      [selectedOptions],
    );

    return (
      <Sheet
        sheetId="poll_done"
        open={module.doneFlowEnabled}
        onOpenChange={module.disableDoneFlow.bind(module)}
        header={
          <YStack gap="$space.small">
            <Title>Decide winning option(s)</Title>
            <Body minHeight={40}>
              {selectedOptions.length
                ? `${selectedOptions.length} option(s) selected`
                : "Select the option(s) you've decided to mark the card as completed"}
            </Body>
          </YStack>
        }
        footer={
          <YStack gap="$medium">
            <TipsText text="When saved you will see the saved options in your Planira" />
            <Button
              onPress={() => module.setDone(selectedOptions)}
              disabled={!selectedOptions.length}
              icon={CheckCircle}
            >
              Save options
            </Button>
          </YStack>
        }
      >
        <DataItemsSelect
          module={module}
          onItemPress={handleOptionSelect}
          activeItems={selectedOptions}
          items={module.pollOptionsSorted.map((option) => ({
            text: option.data.option,
            value: option.data.uid,
            users: option.usersVotedArray,
          }))}
        />
      </Sheet>
    );
  },
);
